import PropTypes from "prop-types";

import i18n from "../../../i18n";

import { Button, Badge } from "@mui/material";

import DeleteAlertDialog from "../../dialog/DeleteAlertDialog";
import useDialog from "../../../hooks/useDialog";

import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import useEquipmentService from "../../../services/equipmentService";
import { useAsync } from "../../../hooks/useAsync";

import {
  overflowButtonStyle,
  centerVericalAlignIconStyle,
} from "../../../helpers/styles";

function DeleteAlertButton(props) {
  const { getEquipmentBmsWithAlertsCount } = useEquipmentService();
  const equipmentBmsWithAlertsCount = useAsync(getEquipmentBmsWithAlertsCount);

  const [
    openDeleteAlertDialog,
    onOpenDeleteAlertDialog,
    onCloseDeleteAlertDialog,
  ] = useDialog();

  return (
    <>
      <Button
        startIcon={<ErrorOutlineIcon sx={centerVericalAlignIconStyle} />}
        color={props.color}
        onClick={onOpenDeleteAlertDialog}
        disabled={!props.selectedItemIds || props.selectedItemIds.length === 0}
        variant="contained"
        size="small"
        sx={overflowButtonStyle}
        fullWidth
      >
        {i18n.t("bar.tool_bar.delete_alerts")}
      </Button>
      <Badge
        badgeContent={equipmentBmsWithAlertsCount?.value?.count}
        color="error"
        sx={{
          "& .MuiBadge-badge": {
            marginRight: "8px",
            marginTop: "-16px",
          },
        }}
        max={999999}
      ></Badge>
      <DeleteAlertDialog
        open={openDeleteAlertDialog}
        onClose={onCloseDeleteAlertDialog}
        itemIds={props.selectedItemIds}
        itemType={props.itemType}
        onSubmit={props.onSubmit}
        refreshAlertCount={equipmentBmsWithAlertsCount.refetch}
      />
    </>
  );
}

DeleteAlertButton.propTypes = {
  color: PropTypes.string,
  selectedItemIds: PropTypes.array,
  itemType: PropTypes.string,
  onSubmit: PropTypes.func,
};

DeleteAlertButton.defaultProps = {
  color: "warning",
  itemType: "equipment_bms",
  selectedItemIds: [],
};

export default DeleteAlertButton;
